<template>
  <transition name="fade">
    <!-- eslint-disable -->
    <div
      v-if="visible"
      class="modal detail_box"
    >
      <div
        class="detail"
        style="height:500px;"
        v-loading='changInfoLoading'
        element-loading-text="修改中，请稍后……"
      >
        <div class="titles msp_icon_close">
          <span class="title_name">修改信息</span>
          <span
            class="iconfont el-icon-close"
            @click.stop="closeBox()"
          />
        </div>
        <div class="detail_el_scroll">
          <div class="bottom_button">
            <div class="bottom_content">
              <el-button
                type="primary"
                @click.native="sureSetMatterInfo()"
              >确定</el-button>
            </div>
          </div>

          <div class="upload_matter_info">
            <div
              class="upload_each_info_detail upload_input_info_detail"
              style="padding-left:68px; box-sizing:border-box;"
            >
              <span class="star">*</span>
              <span>素材名称：</span>
              <el-input
                v-model="uploadPicObj.title"
                placeholder="请输入素材名称"
                maxlength="60"
              ></el-input>
            </div>

            <div class="upload_each_info_detail upload_input_tags_detail">
              <span>素材标签：</span>
              <el-cascader
                v-model="uploadPicObj.tagIds"
                :options="tagsTree"
                :props='cascaderProps'
                :size='cascaderSize'
                :show-all-levels="false"
                ref='cascaderref'
                filterable
                @change="handleChange"
              ></el-cascader>
            </div>
            <div class="upload_each_info_detail">
              <span>关&nbsp;&nbsp;键&nbsp;&nbsp;词：</span>
              <div class="key_words">
                <el-tag
                  :key="tag"
                  v-for="tag in uploadPicObj.keywords"
                  closable
                  :disable-transitions="false"
                  @close="handleClose(tag)"
                >
                  {{tag}}
                </el-tag>
                <el-input
                  class="input-new-tag"
                  v-if="inputVisible"
                  v-model="inputValue"
                  ref="saveTagInput"
                  size="small"
                  maxlength="10"
                  @keyup.enter.native="handleInputConfirm"
                  @blur="handleInputConfirm"
                >
                </el-input>
                <el-button
                  v-else
                  class="button-new-tag"
                  size="small"
                  @click="showInput"
                >+ 添加关键词</el-button>
              </div>
            </div>
            <div class="upload_each_info_detail upload_input_info_detail">
              <span>素材描述：</span>
              <el-input
                type="textarea"
                placeholder="请填写内容"
                v-model="uploadPicObj.detail"
                maxlength="100"
                :show-word-limit='true'
              ></el-input>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import * as api from '../../../api'
export default {
  data () {
    return {
      visible: false,
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        multiple: true,
        emitPath: false,
        checkStrictly: true,
        expandTrigger: 'hover'
      },
      cascaderSize: 'medium',
      inputVisible: false,
      inputValue: '',
      uploadPicObj: {
        'id': '',
        'title': '',
        'tagIds': [], // 必须参数： 标签ID列表
        'tags': [], // 必须参数： 标签列表
        'keywords': [], // 必须参数： 关键词列表
        'detail': '' // 必须参数： 标题
      },
      modifyDataType: '',
      modifyDataInfo: '',
      changInfoLoading: false
    }
  },
  computed: {
    tagsTree () {
      return this.$store.state.tags.matterTagsTree
    }
  },
  watch: {
    visible () {
      if (this.visible === false) {
        this.inputValue = ''
        this.inputVisible = false
        this.uploadPicObj = {
          'id': '',
          'title': '',
          'tagIds': [], // 必须参数： 标签ID列表
          'tags': [], // 必须参数： 标签列表
          'keywords': [], // 必须参数： 关键词列表
          'detail': '' // 必须参数： 标题
        }
      }
    }
  },
  mounted () {
    this.$root.eventHub.$on('singleModifyInfoModel', (data, type) => {
      this.visible = true
      this.modifyDataType = type
      this.modifyDataInfo = data
      var currentData = JSON.parse(JSON.stringify(data))
      for (var key in this.uploadPicObj) {
        if (currentData.hasOwnProperty(key)) {
          this.$set(this.uploadPicObj, key, currentData[key])
        }
      }
    })
  },
  destroyed () {
    this.$root.eventHub.$off('singleModifyInfoModel')
  },
  methods: {
    closeBox () {
      this.visible = false
    },
    handleChange (val, label, data) {
      var node = this.$refs.cascaderref.getCheckedNodes()
      var tags = []
      for (var i = 0; i < node.length; i++) {
        for (var j = 0; j < this.uploadPicObj.tagIds.length; j++) {
          if (node[i].value === this.uploadPicObj.tagIds[j]) {
            tags.push(node[i].label)
          }
        }
      }
      this.uploadPicObj.tags = tags
    },
    handleClose (tag) {
      this.uploadPicObj.keywords.splice(this.uploadPicObj.keywords.indexOf(tag), 1)
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm () {
      let inputValue = this.inputValue
      if (inputValue) {
        this.uploadPicObj.keywords.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },

    sureSetMatterInfo () {
      if (this.modifyDataType === 'picture' || this.modifyDataType === 'video' || this.modifyDataType === 'audio' || this.modifyDataType === 'file') {
        var apiType = ''
        var option = {
          ...this.$store.getters.baseOption,
          params: {
            title: this.uploadPicObj.title,
            keywords: this.uploadPicObj.keywords,
            tags: this.uploadPicObj.tags,
            tagIds: this.uploadPicObj.tagIds,
            detail: this.uploadPicObj.detail,
            ids: [this.uploadPicObj.id],
            type: this.modifyDataType
          }
        }
        if (this.modifyDataType === 'video' || this.modifyDataType === 'audio') {
          apiType = _VIDEOAUDIOURL_
        } else if (this.modifyDataType === 'picture' || this.modifyDataType === 'file') {
          apiType = _IMGFILEURL_
        }
        this.changInfoLoading = true
        api._post(apiType + 'public/editInfo', option).then((resp) => {
          if (resp.code === 200) {
            this.$notify.success({
              title: '成功',
              message: '修改成功'
            })
            for (var key in this.uploadPicObj) {
              if (this.modifyDataInfo.hasOwnProperty(key)) {
                this.$set(this.modifyDataInfo, key, this.uploadPicObj[key])
              }
            }
            this.visible = false

          }
          this.changInfoLoading = false
        }).catch((error) => {
          console.log(error)
          this.changInfoLoading = false
        })

      } else {
        this.visible = false
      }

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
@import '../../../styles/modifyInfo.styl'
</style>
